import React from "react";
import "./Home.css"
import HeroSection from "../../components/HeroSection";
import { Container, Carousel, Row, Col } from 'react-bootstrap';
import Footer from "../../components/Footer";


export default function Home() {
    return (
        <div className="main-bg">

            <div>
                <section className="hero text-center py-5" 
                style={{
                    minHeight: "100vh",
                    position: "relative",
                    backgroundImage: "url('../imgs/herotop.png')",
                    backgroundSize: window.innerWidth <= 768 ? "cover" : "100% 100%",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat"
                }}>
                <nav className="navbar navbar-expand-lg py-3 px-2 px-md-0">
                    <div className="container bg-white rounded-3 shadow-sm py-2 ">
                        <a className="navbar-brand fw-bold d-flex align-items-center" href="#">
                            <img
                                src="../imgs/logomacaparanafooter.png"
                                alt="logo"
                                width="100"
                                className="me-2"
                            />
                            
                        </a>

                        <button
                            className="navbar-toggler"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#navbarNav"
                        >
                            <span className="navbar-toggler-icon"></span>
                        </button>

                        <div className="collapse navbar-collapse" id="navbarNav">
                            <ul className="navbar-nav mx-auto gap-3">

                                <li className="nav-item">
                                    <a className="nav-link" href="#sobre">Sobre o Projeto</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="#como">Como Funciona</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="#beneficios">Benefícios</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="#duvidas">Dúvidas</a>
                                </li>
                            </ul>

                            <a className="btn btn-outline-primary px-4 py-2 rounded-pill" href="/questionario">
                                Acessar Questionário
                            </a>
                        </div>
                    </div>
                </nav>


                
                    <div className="container">
                        <h1 className="fw-bold display-5" style={{ color: "#000C64" }}>
                            Gestão Nutricional <br />
                            Inteligente para Municípios
                        </h1>

                        <p className="mt-3 fs-5 text-dark opacity-75">
                            Solução completa para gerir a merenda e acompanhar a saúde nutricional dos estudantes.
                        </p>

                        <div className="d-flex flex-column flex-md-row justify-content-center mt-4 gap-3">
                            <button className="btn btn-outline-primary px-4 py-2 rounded-pill">
                                <a className="nav-link" href="#como">Ver Passo a Passo</a>
                                
                            </button>

                           <button className="btn px-4 py-2 rounded-pill" style={{color: "white", background: "#002AAD"}}>
                            <i className="bi bi-clipboard2-minus-fill me-2"></i>
                            <a href="/questionario" style={{ color: 'white', textDecoration: 'none' }}>Iniciar Questionário</a>
                            
                        </button>
                        </div>

                    </div>
                </section>
            </div>

            <section className="hero text-center py-5" id="sobre">
                <div className="container">
                    <h1 className="fw-bold display-5" style={{ color: "#000C64" }}>
                        Por dentro do Projeto
                    </h1>

                    <p className="mt-3 fs-5 text-dark opacity-75">
                        Uma visão clara do propósito, das funcionalidades e <br />
                        de quem se beneficia com a solução.
                    </p>
                </div>
            </section>

            <section className="container py-5">
                <div className="d-flex flex-column flex-md-row align-items-center justify-content-center gap-5">

                    {/* COLUNA DA IMAGEM */}
                    <div className="text-center">
                        <img
                            src="../imgs/imgvisaogeral.png"
                            className="img-fluid"
                            alt="Visão Geral"
                            style={{ maxWidth: "360px" }}
                        />
                    </div>

                    {/* COLUNA DO TEXTO E BOTÕES */}
                    <div className="text-center text-md-start px-3 px-md-0">

                        <h1 className="fw-bold display-5" style={{ color: "#000C64" }}>
                            Visão Geral
                        </h1>

                        <p className="mt-3 fs-5 text-dark opacity-75">
                            Uma solução completa que une tecnologia, avaliação nutricional e suporte especializado para modernizar a gestão da merenda escolar e acompanhar a saúde dos alunos com precisão.      </p>

                        <div className="d-flex flex-column flex-md-row justify-content-center justify-content-md-start mt-4 gap-3">
                            <button
                                className="btn px-4 py-2 rounded-pill bg-white border-0 fw-bold"
                                style={{ color: "#white" }}
                            >
                                <a className="nav-link" href="#como">Ver Passo a Passo</a>
                            </button>

                             <button className="btn px-4 py-2 rounded-pill" style={{color: "white", background: "#002AAD"}}>
                            <i className="bi bi-clipboard2-minus-fill me-2"></i>
                            <a href="/questionario" style={{ color: 'white', textDecoration: 'none' }}>Iniciar Questionário</a>
                            
                        </button>
                        </div>

                    </div>

                </div>
            </section>

            <section className="container py-5" id="como">
                <div className="d-flex flex-column flex-md-row align-items-center justify-content-center gap-5">


                    <div className="text-center order-1 order-md-2">
                        <img
                            src="../imgs/imgcomofunciona.png"
                            className="img-fluid"
                            alt="Visão Geral"
                            style={{ maxWidth: "360px" }}
                        />
                    </div>

                    {/* TEXTO — aparece depois da imagem no celular e antes no desktop */}
                    <div className="text-center text-md-start px-3 px-md-0 order-2 order-md-1">

                        <h1 className="fw-bold display-5" style={{ color: "#000C64" }}>
                            Como funciona
                        </h1>

                        <p className="mt-3 fs-5 text-dark opacity-75">
                            O projeto realiza coletas nutricionais in loco, gera laudos individuais e gerais,
                            organiza dados de forma segura e oferece ferramentas digitais para apoiar decisões
                            mais rápidas e estratégicas.
                        </p>

                        <div className="d-flex flex-column flex-md-row justify-content-center justify-content-md-start mt-4 gap-3">
                            <button
                                className="btn px-4 py-2 rounded-pill bg-white border-0 fw-bold"
                                style={{ color: "#000C64" }}
                            >
                                <a className="nav-link" href="#como">Ver Passo a Passo</a>
                            </button>

                              <button className="btn px-4 py-2 rounded-pill" style={{color: "white", background: "#002AAD"}}>
                            <i className="bi bi-clipboard2-minus-fill me-2"></i>
                            <a href="/questionario" style={{ color: 'white', textDecoration: 'none' }}>Iniciar Questionário</a>
                            
                        </button>
                        </div>

                    </div>

                </div>
            </section>

            <section className="container py-5">
                <div className="d-flex flex-column flex-md-row align-items-center justify-content-center gap-5">

                    {/* COLUNA DA IMAGEM */}
                    <div className="text-center">
                        <img
                            src="../imgs/imgpublico.png"
                            className="img-fluid"
                            alt="Visão Geral"
                            style={{ maxWidth: "360px" }}
                        />
                    </div>

                    {/* COLUNA DO TEXTO E BOTÕES */}
                    <div className="text-center text-md-start px-3 px-md-0">

                        <h1 className="fw-bold display-5" style={{ color: "#000C64" }}>
                            Público-Alvo
                        </h1>

                        <p className="mt-3 fs-5 text-dark opacity-75">
                            Desenvolvido para prefeituras, secretarias de Educação e Saúde, gestores escolares e equipes de nutrição que buscam otimizar processos, garantir transparência e aprimorar o cuidado com todos os estudantes matriculados na rede municipal de ensino (crianças, jovens, adultos e idosos).                                </p>

                        <div className="d-flex flex-column flex-md-row justify-content-center justify-content-md-start mt-4 gap-3">
                            <button
                                className="btn px-4 py-2 rounded-pill bg-white border-0 fw-bold"
                                style={{ color: "#000C64" }}
                            >
                                <a className="nav-link" href="#como">Ver Passo a Passo</a>
                            </button>


                             <button className="btn px-4 py-2 rounded-pill" style={{color: "white", background: "#002AAD"}}>
                            <i className="bi bi-clipboard2-minus-fill me-2"></i>
                            <a href="/questionario" style={{ color: 'white', textDecoration: 'none' }}>Iniciar Questionário</a>
                            
                        </button>
                        </div>

                    </div>

                </div>
            </section>
            <section className="hero text-center py-5" id="beneficios">
                <div className="container">
                    <h1 className="fw-bold display-5" style={{ color: "#000C64" }}>
                        Vantagens do Projeto
                    </h1>

                    <p className="mt-3 fs-5 text-dark opacity-75">
                        Benefícios pensados para facilitar a rotina, otimizar <br />
                        decisões e gerar impacto positivo.
                    </p>
                </div>
            </section>
            <div style={{ width: '100%', padding: '40px 0' }}>
                <Container>
                    <Row className="justify-content-center ">
                        <Col md={3} className="mb-3">
                            
                                <div
                                    className="p-4 rounded shadow-sm h-100 d-flex flex-column align-items-start justify-content-start option-card w-100"
                                    style={{
                                        backgroundColor: "#E4F2FF",
                                        color: "#333",
                                        transition: "transform 0.2s, box-shadow 0.2s",
                                        cursor: "pointer",
                                    }}
                                >
                                    <div
                                        className="top-icon-box d-flex align-items-center justify-content-center mb-3"
                                        style={{
                                            backgroundColor: "#DCEBFF",
                                            width: "56px",
                                            height: "40px",
                                            borderRadius: "12px",
                                        }}
                                    >
                                        <i className="bi bi-shield-fill-check" style={{ color: "#000C64", fontSize: "18px" }}></i>
                                    </div>
                                    <div className="w-100">
                                        <h2 className="fw-bold fs-5 text-start" style={{ color: "#000C64" }}>
                                            Dados Seguros e Inteligentes
                                        </h2>

                                        <p className="fs-6 mt-2 mb-0 text-start text-dark opacity-75">
                                            Coleta e análise detalhada das informações nutricionais, garantindo segurança, laudos completos e questionários socioeconômicos acessíveis.                                              </p>
                                    </div>
                                </div>
                            
                        </Col>


                        <Col md={3} className="mb-3">
                            
                                <div
                                    className="p-4 rounded shadow-sm h-100 d-flex flex-column align-items-start justify-content-start option-card w-100"
                                    style={{
                                        backgroundColor: "#E4F2FF",
                                        color: "#333",
                                        transition: "transform 0.2s, box-shadow 0.2s",
                                        cursor: "pointer",
                                    }}
                                >
                                    <div
                                        className="top-icon-box d-flex align-items-center justify-content-center mb-3"
                                        style={{
                                            backgroundColor: "#DCEBFF",
                                            width: "56px",
                                            height: "40px",
                                            borderRadius: "12px",
                                        }}
                                    >
                                        <i className="bi bi-megaphone-fill" style={{ color: "#000C64", fontSize: "18px" }}></i>
                                    </div>
                                    <div className="w-100">
                                        <h2 className="fw-bold fs-5 text-start" style={{ color: "#000C64" }}>
                                            Resultados Claros e Participativos
                                        </h2>

                                        <p className="fs-6 mt-2 mb-0 text-start text-dark opacity-75">
                                            Entregas transparentes para gestores, escolas e famílias, com apresentações, laudos e ações que fortalecem o envolvimento da comunidade escolar.                                                  </p>
                                    </div>
                                </div>
                            
                        </Col>


                        <Col md={3} className="mb-3">
                           
                                <div
                                    className="p-4 rounded shadow-sm h-100 d-flex flex-column align-items-start justify-content-start option-card w-100"
                                    style={{
                                        backgroundColor: "#E4F2FF",
                                        color: "#333",
                                        transition: "transform 0.2s, box-shadow 0.2s",
                                        cursor: "pointer",
                                    }}
                                >

                                    <div
                                        className="top-icon-box d-flex align-items-center justify-content-center mb-3"
                                        style={{
                                            backgroundColor: "#DCEBFF",
                                            width: "56px",
                                            height: "40px",
                                            borderRadius: "12px",
                                        }}
                                    >
                                        <i className="bi bi-file-bar-graph-fill" style={{ color: "#000C64", fontSize: "18px" }}></i>
                                    </div>
                                    <div className="w-100">
                                        <h2 className="fw-bold fs-5 text-start" style={{ color: "#000C64" }}>
                                            Gestão Fortalecida e Suporte Contínuo
                                        </h2>

                                        <p className="fs-6 mt-2 mb-0 text-start text-dark opacity-75">
                                            Plataforma white label que valoriza a prefeitura e assessoria técnica constante para nutricionistas, apoiando decisões e ações de saúde.        </p>
                                    </div>
                                </div>
                            
                        </Col>


                    </Row>
                </Container>
            </div>

            <section className="hero text-center py-5" style={{ background: "#E4F2FF" }}>
                <div className="container">
                    <h1 className="fw-bold display-5" style={{ color: "#000C64" }}>
                        Como o Projeto Acontece na Prática
                    </h1>

                    <p className="mt-3 fs-5 text-dark opacity-75">
                        Etapas organizadas que garantem eficiência, clareza e resultados reais.
                    </p>
                </div>

                <div className="my-5 d-flex justify-content-center">
                    {/* wrapper centralizado da seção */}
                    <div className="my-5 d-flex justify-content-center">
                        <div
                            style={{
                                maxWidth: "1100px",
                                width: "100%",
                                margin: "0 auto",

                            }}
                        >

                            {/* TÍTULO */}
                            <div className="mb-4 text-start">
                                <div
                                    className="d-inline-flex align-items-center px-3 py-2 rounded-pill shadow-sm"
                                    style={{
                                        background: "#fff",
                                        border: "1px solid #d9d9d9",
                                        fontWeight: 600,
                                        marginLeft: "40px"
                                    }}
                                >
                                    <div
                                        className="me-3 d-flex justify-content-center align-items-center"
                                        style={{
                                            width: "35px",
                                            height: "35px",
                                            borderRadius: "50%",
                                            background: "#E4F2FF",
                                            color: "#000C64",
                                            fontWeight: "bold",
                                            fontSize: "0.95rem"
                                        }}
                                    >
                                        1
                                    </div>

                                    <span style={{ color: "#000C64", marginLeft: "4px" }}>
                                        Mapeamento Operacional
                                    </span>
                                </div>
                            </div>

                            {/* CONTEÚDO */}
                            <Row className="g-4 align-items-center">
                                {/* IMAGEM */}
                                <Col md={6} xs={12} className="d-flex justify-content-center">
                                    <img
                                        src="../imgs/imgplanejamento.png"
                                        alt="Mapeamento"
                                        style={{
                                            width: "100%",
                                            maxWidth: "360px",
                                            borderRadius: "20px",
                                            display: "block"
                                        }}
                                    />
                                </Col>

                                {/* CARDS */}
                                <Col md={6} xs={12} className="d-flex flex-column justify-content-center gap-2 px-4 px-md-0">

                                    {/* ITEM 1 */}
                                    <div
                                        className="d-flex align-items-center p-3 shadow-sm"
                                        style={{ background: "#fff", border: "1px solid #d9d9d9", borderRadius: "20px" }}
                                    >
                                        <div
                                            className="d-flex justify-content-center align-items-center me-3"
                                            style={{
                                                width: "10px",
                                                height: "40px",
                                                borderRadius: "50%",
                                                background: "#E4F2FF",
                                                color: "#000C64",
                                                flex: "0 0 40px"
                                            }}
                                        >
                                            <i class="bi bi-person-square"></i>
                                        </div>
                                        <span className="fw-semibold text-dark">
                                            Alinhamento inicial com diretores
                                        </span>
                                    </div>

                                    {/* ITEM 2 */}
                                    <div
                                        className="d-flex align-items-center p-3 shadow-sm"
                                        style={{ background: "#fff", border: "1px solid #d9d9d9", borderRadius: "20px" }}
                                    >
                                        <div
                                            className="d-flex justify-content-center align-items-center me-3"
                                            style={{
                                                width: "40px",
                                                height: "40px",
                                                borderRadius: "50%",
                                                background: "#E4F2FF",
                                                color: "#000C64",
                                                flex: "0 0 40px"
                                            }}
                                        >
                                            <i class="bi bi-mortarboard-fill"></i>
                                        </div>
                                        <span className="fw-semibold text-dark">
                                            Cadastro organizado de escolas e alunos
                                        </span>
                                    </div>

                                    {/* ITEM 3 */}
                                    <div
                                        className="d-flex align-items-center p-3  shadow-sm"
                                        style={{ background: "#fff", border: "1px solid #d9d9d9", borderRadius: "20px" }}
                                    >
                                        <div
                                            className="d-flex justify-content-center align-items-center me-3"
                                            style={{
                                                width: "40px",
                                                height: "40px",
                                                borderRadius: "50%",
                                                background: "#E4F2FF",
                                                color: "#000C64",
                                                flex: "0 0 40px"
                                            }}
                                        >
                                            <i class="bi bi-calendar4-week"></i>
                                        </div>
                                        <span className="fw-semibold text-dark">
                                            Definição do plano de ação e cronograma das atividades
                                        </span>
                                    </div>
                                </Col>

                            </Row>
                        </div>
                    </div>


                </div>

                <div className="my-5 d-flex justify-content-center">

                    <div className="my-5 d-flex justify-content-center">
                        <div
                            style={{
                                maxWidth: "1100px",
                                width: "100%",
                                margin: "0 auto",

                            }}
                        >


                            <div className="mb-4 w-100 text-center text-md-start">
                                <div
                                    className="d-inline-flex align-items-center px-3 py-2 rounded-pill shadow-sm title-pill"
                                    style={{
                                        background: "#fff",
                                        border: "1px solid #d9d9d9",
                                        fontWeight: 600,

                                    }}
                                >
                                    <div
                                        className="me-3 d-flex justify-content-center align-items-center"
                                        style={{
                                            width: "35px",
                                            height: "35px",
                                            borderRadius: "50%",
                                            background: "#E4F2FF",
                                            color: "#000C64",
                                            fontWeight: "bold",
                                            fontSize: "0.95rem"
                                        }}
                                    >
                                        2
                                    </div>

                                    <span style={{ color: "#000C64", marginLeft: "4px" }}>
                                        Projeto Nutrir
                                    </span>
                                </div>
                            </div>


                            {/* CONTEÚDO */}
                            <Row className="g-4 align-items-center">
                                {/* IMAGEM */}
                                <Col md={6} xs={12} className="d-flex justify-content-center">
                                    <img
                                        src="../imgs/imgoperacaonutrir.png"
                                        alt="Mapeamento"
                                        style={{
                                            width: "100%",
                                            maxWidth: "360px",
                                            borderRadius: "20px",
                                            display: "block"
                                        }}
                                    />
                                </Col>

                                {/* CARDS */}
                                <Col md={6} xs={12} className="d-flex flex-column justify-content-center gap-2 px-4 px-md-0">

                                    {/* ITEM 1 */}
                                    <div
                                        className="d-flex align-items-center p-3 shadow-sm"
                                        style={{ background: "#fff", border: "1px solid #d9d9d9", borderRadius: "20px" }}
                                    >
                                        <div
                                            className="d-flex justify-content-center align-items-center me-3"
                                            style={{
                                                width: "10px",
                                                height: "40px",
                                                borderRadius: "50%",
                                                background: "#E4F2FF",
                                                color: "#000C64",
                                                flex: "0 0 40px"
                                            }}
                                        >
                                            <i class="bi bi-clipboard2-pulse"></i>

                                        </div>
                                        <span className="fw-semibold text-dark">
                                            Realização das avaliações nutricionais in loco em todos os alunos matriculados na rede municipal de ensino
                                        </span>
                                    </div>

                                    {/* ITEM 2 */}
                                    <div
                                        className="d-flex align-items-center p-3 shadow-sm"
                                        style={{ background: "#fff", border: "1px solid #d9d9d9", borderRadius: "20px" }}
                                    >
                                        <div
                                            className="d-flex justify-content-center align-items-center me-3"
                                            style={{
                                                width: "40px",
                                                height: "40px",
                                                borderRadius: "50%",
                                                background: "#E4F2FF",
                                                color: "#000C64",
                                                flex: "0 0 40px"
                                            }}
                                        >
                                            <i class="bi bi-qr-code"></i>
                                        </div>
                                        <span className="fw-semibold text-dark">
                                            Aplicação do Questionário Socioeconômico via QR-Code
                                        </span>
                                    </div>

                                    {/* ITEM 3 */}
                                    <div
                                        className="d-flex align-items-center p-3  shadow-sm"
                                        style={{ background: "#fff", border: "1px solid #d9d9d9", borderRadius: "20px" }}
                                    >
                                        <div
                                            className="d-flex justify-content-center align-items-center me-3"
                                            style={{
                                                width: "40px",
                                                height: "40px",
                                                borderRadius: "50%",
                                                background: "#E4F2FF",
                                                color: "#000C64",
                                                flex: "0 0 40px"
                                            }}
                                        >
                                            <i class="bi bi-pie-chart-fill"></i>
                                        </div>
                                        <span className="fw-semibold text-dark">
                                            Geração dos laudos individuais e escolares com base nas coletas
                                        </span>
                                    </div>
                                </Col>

                            </Row>
                        </div>
                    </div>


                </div>

                <div className="my-5 d-flex justify-content-center">

                    <div className="my-5 d-flex justify-content-center">
                        <div
                            style={{
                                maxWidth: "1100px",
                                width: "100%",
                                margin: "0 auto",

                            }}
                        >


                            <div className="mb-4 w-100 text-center text-md-start">
                                <div
                                    className="d-inline-flex align-items-center px-3 py-2 rounded-pill shadow-sm title-entrega-resultado"
                                    style={{
                                        background: "#fff",
                                        border: "1px solid #d9d9d9",
                                        fontWeight: 600,

                                    }}
                                >
                                    <div
                                        className="me-3 d-flex justify-content-center align-items-center"
                                        style={{
                                            width: "35px",
                                            height: "35px",
                                            borderRadius: "50%",
                                            background: "#E4F2FF",
                                            color: "#000C64",
                                            fontWeight: "bold",
                                            fontSize: "0.95rem"
                                        }}
                                    >
                                        3
                                    </div>

                                    <span style={{ color: "#000C64", marginLeft: "4px" }}>
                                        Entrega de Resultados
                                    </span>
                                </div>
                            </div>


                            {/* CONTEÚDO */}
                            <Row className="g-4 align-items-center">
                                {/* IMAGEM */}
                                <Col md={6} xs={12} className="d-flex justify-content-center">
                                    <img
                                        src="../imgs/imgentregaresultado.png"
                                        alt="Mapeamento"
                                        style={{
                                            width: "100%",
                                            maxWidth: "360px",
                                            borderRadius: "20px",
                                            display: "block"
                                        }}
                                    />
                                </Col>

                                {/* CARDS */}
                                <Col md={6} xs={12} className="d-flex flex-column justify-content-center gap-2 px-4 px-md-0">

                                    {/* ITEM 1 */}
                                    <div
                                        className="d-flex align-items-center p-3 shadow-sm"
                                        style={{ background: "#fff", border: "1px solid #d9d9d9", borderRadius: "20px" }}
                                    >
                                        <div
                                            className="d-flex justify-content-center align-items-center me-3"
                                            style={{
                                                width: "10px",
                                                height: "40px",
                                                borderRadius: "50%",
                                                background: "#E4F2FF",
                                                color: "#000C64",
                                                flex: "0 0 40px"
                                            }}
                                        >
                                            <i class="bi bi-clipboard-data"></i>

                                        </div>
                                        <span className="fw-semibold text-dark">
                                            Apresentação dos dados consolidados à Secretaria                                        </span>
                                    </div>

                                    {/* ITEM 2 */}
                                    <div
                                        className="d-flex align-items-center p-3 shadow-sm"
                                        style={{ background: "#fff", border: "1px solid #d9d9d9", borderRadius: "20px" }}
                                    >
                                        <div
                                            className="d-flex justify-content-center align-items-center me-3"
                                            style={{
                                                width: "40px",
                                                height: "40px",
                                                borderRadius: "50%",
                                                background: "#E4F2FF",
                                                color: "#000C64",
                                                flex: "0 0 40px"
                                            }}
                                        >
                                            <i class="bi bi-mortarboard"></i>
                                        </div>
                                        <span className="fw-semibold text-dark">
                                            Entrega dos laudos nas escolas para pais, professores e gestores                                        </span>
                                    </div>

                                    {/* ITEM 3 */}
                                    <div
                                        className="d-flex align-items-center p-3  shadow-sm"
                                        style={{ background: "#fff", border: "1px solid #d9d9d9", borderRadius: "20px" }}
                                    >
                                        <div
                                            className="d-flex justify-content-center align-items-center me-3"
                                            style={{
                                                width: "40px",
                                                height: "40px",
                                                borderRadius: "50%",
                                                background: "#E4F2FF",
                                                color: "#000C64",
                                                flex: "0 0 40px"
                                            }}
                                        >
                                            <i class="bi bi-person-lines-fill"></i>
                                        </div>
                                        <span className="fw-semibold text-dark">
                                            Consultoria nutricional para orientar ações e esclarecer dúvidas da comunidade                                        </span>
                                    </div>
                                </Col>

                            </Row>
                        </div>
                    </div>


                </div>
                <div className="my-5 d-flex justify-content-center">

                    <div className="my-5 d-flex justify-content-center">
                        <div
                            style={{
                                maxWidth: "1100px",
                                width: "100%",
                                margin: "0 auto",

                            }}
                        >


                            <div className="mb-4 w-100 text-center text-md-start">
                                <div
                                    className="d-inline-flex align-items-center px-3 py-2 rounded-pill shadow-sm title-implantacao"
                                    style={{
                                        background: "#fff",
                                        border: "1px solid #d9d9d9",
                                        fontWeight: 600,

                                    }}
                                >
                                    <div
                                        className="me-3 d-flex justify-content-center align-items-center"
                                        style={{
                                            width: "35px",
                                            height: "35px",
                                            borderRadius: "50%",
                                            background: "#E4F2FF",
                                            color: "#000C64",
                                            fontWeight: "bold",
                                            fontSize: "0.95rem"
                                        }}
                                    >
                                        4
                                    </div>

                                    <span style={{ color: "#000C64", marginLeft: "4px" }}>
                                        Implantação de Software
                                    </span>
                                </div>
                            </div>


                            {/* CONTEÚDO */}
                            <Row className="g-4 align-items-center">
                                {/* IMAGEM */}
                                <Col md={6} xs={12} className="d-flex justify-content-center">
                                    <img
                                        src="../imgs/imgimplantacao.png"
                                        alt="Mapeamento"
                                        style={{
                                            width: "100%",
                                            maxWidth: "360px",
                                            borderRadius: "20px",
                                            display: "block"
                                        }}
                                    />
                                </Col>

                                {/* CARDS */}
                                <Col md={6} xs={12} className="d-flex flex-column justify-content-center gap-2 px-4 px-md-0">

                                    {/* ITEM 1 */}
                                    <div
                                        className="d-flex align-items-center p-3 shadow-sm"
                                        style={{ background: "#fff", border: "1px solid #d9d9d9", borderRadius: "20px" }}
                                    >
                                        <div
                                            className="d-flex justify-content-center align-items-center me-3"
                                            style={{
                                                width: "10px",
                                                height: "40px",
                                                borderRadius: "50%",
                                                background: "#E4F2FF",
                                                color: "#000C64",
                                                flex: "0 0 40px"
                                            }}
                                        >
                                            <i class="bi bi-pc-display"></i>

                                        </div>
                                        <span className="fw-semibold text-dark">
                                            Instalação e configuração do sistema de gestão da merenda                                        </span>
                                    </div>

                                    {/* ITEM 2 */}
                                    <div
                                        className="d-flex align-items-center p-3 shadow-sm"
                                        style={{ background: "#fff", border: "1px solid #d9d9d9", borderRadius: "20px" }}
                                    >
                                        <div
                                            className="d-flex justify-content-center align-items-center me-3"
                                            style={{
                                                width: "40px",
                                                height: "40px",
                                                borderRadius: "50%",
                                                background: "#E4F2FF",
                                                color: "#000C64",
                                                flex: "0 0 40px"
                                            }}
                                        >
                                            <i class="bi bi-people-fill"></i>
                                        </div>
                                        <span className="fw-semibold text-dark">
                                            Treinamento da equipe para dominar todas as funcionalidades
                                        </span>
                                    </div>

                                    {/* ITEM 3 */}
                                    <div
                                        className="d-flex align-items-center p-3  shadow-sm"
                                        style={{ background: "#fff", border: "1px solid #d9d9d9", borderRadius: "20px" }}
                                    >
                                        <div
                                            className="d-flex justify-content-center align-items-center me-3"
                                            style={{
                                                width: "40px",
                                                height: "40px",
                                                borderRadius: "50%",
                                                background: "#E4F2FF",
                                                color: "#000C64",
                                                flex: "0 0 40px"
                                            }}
                                        >
                                            <i class="bi bi-flag"></i>

                                        </div>
                                        <span className="fw-semibold text-dark">
                                            Suporte inicial para garantir uma transição tranquila e eficiente                                       </span>
                                    </div>
                                </Col>

                            </Row>
                        </div>
                    </div>


                </div>
            </section>
            <section
                className="hero-gradiente text-center py-5"
                style={{
                    background: "linear-gradient(180deg, #E4F2FF 0%, #C1E3F7 50%, #9DD5EF 100%)"
                }}
            >
                <div className="container" id="duvidas">
                    <h1 className="fw-bold display-5" style={{ color: "#000C64" }}>
                        Perguntas Frequentes
                    </h1>

                    <p className="mt-3 fs-5 text-dark opacity-75">
                        Respostas rápidas para as dúvidas mais comuns.
                    </p>

                    <div style={{ width: '100%', padding: '40px 0' }}>
                        <Container>
                            <Row className="justify-content-center ">
                                <Col md={3} className="mb-3">

                                    <div
                                        className="p-4 rounded shadow-sm h-100 d-flex flex-column align-items-start justify-content-start option-card w-100"
                                        style={{
                                            backgroundColor: "#002AAD",
                                            color: "#333",
                                            transition: "transform 0.2s, box-shadow 0.2s",
                                            cursor: "pointer",
                                        }}
                                    >
                                        <div
                                            className="top-icon-box d-flex align-items-center justify-content-center mb-3"
                                            style={{
                                                backgroundColor: "white",
                                                width: "76px",
                                                height: "5px",
                                                borderRadius: "12px",
                                            }}
                                        >

                                        </div>
                                        <div className="w-100">
                                            <h2 className="fw-bold fs-5 text-start" style={{ color: "white" }}>
                                                Dados Seguros e Inteligentes
                                            </h2>

                                            <p className="text-start" style={{ color: "white" }}>
                                                Coleta e análise detalhada das informações nutricionais, garantindo segurança, laudos completos e questionários socioeconômicos de fácil acesso.                                              </p>
                                        </div>
                                    </div>

                                </Col>

                                <Col md={3} className="mb-3">

                                    <div
                                        className="p-4 rounded shadow-sm h-100 d-flex flex-column align-items-start justify-content-start option-card w-100"
                                        style={{
                                            backgroundColor: "#002AAD",
                                            color: "#333",
                                            transition: "transform 0.2s, box-shadow 0.2s",
                                            cursor: "pointer",
                                        }}
                                    >
                                        <div
                                            className="top-icon-box d-flex align-items-center justify-content-center mb-3"
                                            style={{
                                                backgroundColor: "white",
                                                width: "76px",
                                                height: "5px",
                                                borderRadius: "12px",
                                            }}
                                        >

                                        </div>
                                        <div className="w-100">
                                            <h2 className="fw-bold fs-5 text-start" style={{ color: "white" }}>
                                                A coleta dos dados precisa ser feita presencialmente?
                                            </h2>

                                            <p className="text-start" style={{ color: "white" }}>
                                                Sim. As avaliações antropométricas (peso, altura, circunferência da cintura e do braço) são realizadas presencialmente para garantir precisão e padronização.                                              </p>
                                        </div>
                                    </div>

                                </Col>

                                <Col md={3} className="mb-3">

                                    <div
                                        className="p-4 rounded shadow-sm h-100 d-flex flex-column align-items-start justify-content-start option-card w-100"
                                        style={{
                                            backgroundColor: "#002AAD",
                                            color: "#333",
                                            transition: "transform 0.2s, box-shadow 0.2s",
                                            cursor: "pointer",
                                        }}
                                    >
                                        <div
                                            className="top-icon-box d-flex align-items-center justify-content-center mb-3"
                                            style={{
                                                backgroundColor: "white",
                                                width: "76px",
                                                height: "5px",
                                                borderRadius: "12px",
                                            }}
                                        >

                                        </div>
                                        <div className="w-100">
                                            <h2 className="fw-bold fs-5 text-start" style={{ color: "white" }}>
                                                Como os resultados são entregues ao município?
                                            </h2>

                                            <p className="text-start" style={{ color: "white" }}>
                                                Os dados geram laudos completos que são apresentados à Secretaria e entregues às escolas, junto com orientações nutricionais para pais, professores e gestores.                                             </p>
                                        </div>
                                    </div>

                                </Col>


                            </Row>
                        </Container>
                    </div>
                    <div style={{ width: '100%', padding: '40px 0' }}>
                        <Container>
                            <Row className="justify-content-center ">
                                <Col md={3} className="mb-3">

                                    <div
                                        className="p-4 rounded shadow-sm h-100 d-flex flex-column align-items-start justify-content-start option-card w-100"
                                        style={{
                                            backgroundColor: "#002AAD",
                                            color: "#333",
                                            transition: "transform 0.2s, box-shadow 0.2s",
                                            cursor: "pointer",
                                        }}
                                    >
                                        <div
                                            className="top-icon-box d-flex align-items-center justify-content-center mb-3"
                                            style={{
                                                backgroundColor: "white",
                                                width: "76px",
                                                height: "5px",
                                                borderRadius: "12px",
                                            }}
                                        >

                                        </div>
                                        <div className="w-100">
                                            <h2 className="fw-bold fs-5 text-start" style={{ color: "white" }}>
                                                O acesso às informações é seguro e confiável?
                                            </h2>

                                            <p className="text-start" style={{ color: "white" }}>
                                                Sim. Todas as coletas e relatórios seguem protocolos de segurança, garantindo dados protegidos e resultados confiáveis para tomada de decisão.                                           </p>
                                        </div>
                                    </div>

                                </Col>

                                <Col md={3} className="mb-3">

                                    <div
                                        className="p-4 rounded shadow-sm h-100 d-flex flex-column align-items-start justify-content-start option-card w-100"
                                        style={{
                                            backgroundColor: "#002AAD",
                                            color: "#333",
                                            transition: "transform 0.2s, box-shadow 0.2s",
                                            cursor: "pointer",
                                        }}
                                    >
                                        <div
                                            className="top-icon-box d-flex align-items-center justify-content-center mb-3"
                                            style={{
                                                backgroundColor: "white",
                                                width: "76px",
                                                height: "5px",
                                                borderRadius: "12px",
                                            }}
                                        >

                                        </div>
                                        <div className="w-100">
                                            <h2 className="fw-bold fs-5 text-start" style={{ color: "white" }}>
                                                Quem pode utilizar o projeto?
                                            </h2>

                                            <p className="text-start" style={{ color: "white" }}>
                                                Prefeituras e Secretarias de Educação ou Saúde que desejam organizar a gestão da merenda e acompanhar a saúde nutricional dos alunos de forma eficiente.                                              </p>
                                        </div>
                                    </div>

                                </Col>

                                <Col md={3} className="mb-3">

                                    <div
                                        className="p-4 rounded shadow-sm h-100 d-flex flex-column align-items-start justify-content-start option-card w-100"
                                        style={{
                                            backgroundColor: "#002AAD",
                                            color: "#333",
                                            transition: "transform 0.2s, box-shadow 0.2s",
                                            cursor: "pointer",
                                        }}
                                    >
                                        <div
                                            className="top-icon-box d-flex align-items-center justify-content-center mb-3"
                                            style={{
                                                backgroundColor: "white",
                                                width: "76px",
                                                height: "5px",
                                                borderRadius: "12px",
                                            }}
                                        >

                                        </div>
                                        <div className="w-100">
                                            <h2 className="fw-bold fs-5 text-start" style={{ color: "white" }}>
                                                Há suporte após a implementação?
                                            </h2>

                                            <p className="text-start" style={{ color: "white" }}>
                                                Sim. Oferecemos acompanhamento contínuo para a equipe responsável, garantindo orientação na análise de resultados e nas decisões estratégicas.                                             </p>
                                        </div>
                                    </div>

                                </Col>


                            </Row>
                        </Container>
                    </div>

                </div>
            </section>
            <section
                className="text-center py-5"
                style={{
                    minHeight: "100vh",
                    position: "relative",
                    backgroundImage: "url('/imgs/Herobtm.png')",
                    backgroundSize: window.innerWidth <= 768 ? "cover" : "100% 100%",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat"
                }}
            >
                {/* overlay opcional */}
                <div
                    style={{
                        position: "absolute",
                        inset: 0,

                        zIndex: 1
                    }}
                />

                {/* CONTEÚDO POR CIMA */}
                <div
                    className="container"
                    style={{
                        position: "relative",
                        zIndex: 2
                    }}
                >
                    <h1 className="fw-bold display-5" style={{ color: "#000C64" }}>
                        A Solução Completa para a Merenda <br />
                        Escolar do Seu Município
                    </h1>

                    <p className="mt-3 fs-5 text-dark opacity-75">
                        Tecnologia, organização e saúde trabalhando juntas pela sua rede de ensino.
                    </p>

                    <div className="d-flex flex-column flex-md-row justify-content-center mt-4 gap-3">
                         <button className="btn px-4 py-2 rounded-pill" style={{color: "white", background: "#002AAD"}}>
                            <i className="bi bi-clipboard2-minus-fill me-2"></i>
                            <a href="/questionario" style={{ color: 'white', textDecoration: 'none' }}>Iniciar Questionário</a>
                            
                        </button>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
}